// extracted by mini-css-extract-plugin
module.exports = {"pullquote":"PullQuote_pullquote__bOEWA","styleSolid":"PullQuote_styleSolid__O021I","wrap":"PullQuote_wrap__XBekL"};